import { Root } from "./Toggle.style"
import ToggleIcon from "../Icons/PostmarkArrow"

const Toggle = ({ className, onClick }) => (
  <Root className={className} onClick={onClick}>
    <ToggleIcon />
  </Root>
)

export default Toggle
